import createFatalErrorStream from './Streams/createFatalErrorStream';
import subscribeToFatalErrorStream from './Subscriptions/subscribeToFatalErrorStream';

const connectErrorSubscriptions = middleware => {
    const { player, errorsHandler: { reportError$ } } = middleware;
    return  [
        subscribeToFatalErrorStream(
            createFatalErrorStream(reportError$),
            player,
        ),
    ];
};

export default connectErrorSubscriptions;
